module.exports = __webpack_public_path__ + "static/media/998102.3bdd29a9.png";